module.exports = __webpack_public_path__ + "static/media/report-aura-background.f4cde0ac.svg";